<template>
  <BaseForm
    lang="en"
    :close="handleClose"
    :open-message="handleOpenMessage"
    container-class="modal-question-form-body--question"
    banner-class="modal-question-form-banner--question"
    inputs-container-class="modal-question-form__inputs--question"
    checkbox-container-class="styled-checkbox--question"
    :translations="translations"
    :show-banner-image="false"
    :show-company-url="false"
    :show-plans-count="false"
    :show-question="true"
    :show-house-icon="false"
    form-type="view">

    <template #custom-question-field>
      <div class="styled-input__container">
        <img src="@/assets/img/question-form/question-icon.svg" alt="question-icon" />
        <textarea
          @focus="activeField = 'question'"
          @blur="activeField = null"
          :placeholder="translations.en.question_placeholder"
          name="question"
          v-model="question"
          data-question-form="question"
          rows="3"></textarea>
      </div>
    </template>

  </BaseForm>
</template>

<script setup>
import { ref } from 'vue';
import BaseForm from '@/Components/En/Modals/BaseForm.vue';

const translations = ref({
  en: {
    name_placeholder: 'Name*',
    email_placeholder: 'Email*',
    privacy: 'By clicking “Send,” I agree to the <a href="/privacy-policy" class="link" target="_blank">processing of my personal data</a>. Learn more in our <a href="/privacy-policy" class="link" target="_blank">Privacy Policy</a>',
    question_placeholder: 'I would like to upload my view through the window. Please, send me how can I do it?',
    send: 'Send',
    title: 'The custom view request',
    subtitle: 'Make your 360 tour extra custom',
  },
  ru: {
    name_placeholder: 'Имя*',
    email_placeholder: 'Электронная почта*',
    privacy: 'Нажимая кнопку «Отправить», я даю согласие на <a href="/agreement" class="link" target="_blank">обработку персональных данных</a>. Узнать больше о <a href="/privacy-policy" class="link" target="_blank">политике конфиденциальности</a>',
    question_placeholder: 'Я хочу загрузить свою панораму вида из окна. Как я могу это сделать?',
    send: 'Send',
    title: 'Хотите свой вид из окна?',
    subtitle: 'Сделайте тур 360 еще более реалистичным',
  },
});

defineExpose();
</script>
